<template>
  <div
    v-if="show && waterway"
    class="customer-popup-overlay"
    @click.self="$emit('close')"
  >
    <div class="customer-popup-content">
      <!-- Header -->
      <div class="customer-popup-header">
        <div>
          <h3 class="customer-popup-title">{{ waterway.name || 'Unnamed Waterway' }}</h3>
          
        </div>
        <button @click="$emit('close')" class="customer-popup-close" aria-label="Close">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>
      
      <!-- Body -->
      <div class="customer-popup-body">
        <div class="customer-popup-section">
          <div class="port-stats-table">
            <table>
              <tbody>
                <tr>
                  <th>Class</th>
                  <td>{{ getClassificationLabel(waterway.classification) }}</td>
                </tr>
                <tr>
                  <th>Miles</th>
                  <td>{{ formatLength(waterway.length_miles) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      
      <!-- Footer -->
      <div class="customer-popup-footer">
        <button @click="$emit('close')" class="customer-popup-button">
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WaterwayPopup',
  
  props: {
    waterway: {
      type: Object,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    }
  },

  mounted() {
    document.addEventListener('keydown', this.handleEscKey);
  },
  
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleEscKey);
  },
  
  methods: {
    handleEscKey(event) {
      if (event.key === 'Escape' && this.show) {
        this.$emit('close');
      }
    },
    
    formatLength(miles) {
      if (miles === null || miles === undefined) return '-';
      const num = parseFloat(miles);
      if (isNaN(num)) return '-';
      return num.toFixed(2);
    },
    
    getClassificationLabel(classification) {
      switch (classification) {
        case 1:
          return 'Class 1 - Major Waterway';
        case 2:
          return 'Class 2 - Secondary Waterway';
        case 3:
          return 'Class 3 - Minor Waterway';
        default:
          return 'Unclassified';
      }
    },
    
    getClassificationBadgeClass(classification) {
      return `waterway-classification-badge waterway-class-${classification || 2}`;
    }
  }
};
</script>
